import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IConfirmModalData } from './models/confirmModalData';
import { IConfirmModalAnswer } from './models/confirmModalAnswer';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['confirm-modal.component.scss'],
    standalone: false
})
export class ConfirmModalComponent {
	checkBoxFormControl: FormControl<boolean> = new FormControl<boolean>(false);
	config: IConfirmModalData;

	constructor(
		private dialogRef: MatDialogRef<ConfirmModalComponent>,
		@Inject(MAT_DIALOG_DATA) private data: IConfirmModalData
	) {
		this.config = { ...this.data };
		this.dialogRef
			.beforeClosed()
			.subscribe((result: IConfirmModalAnswer | undefined) => {
				if (result === undefined) this.close();
			});
	}

	apply(): void {
		const answer: IConfirmModalAnswer = {
			answer: true,
			checkBoxState: this.checkBoxFormControl.value
		}
		this.dialogRef.close(answer);
	}

	cancel(): void {
		const answer: IConfirmModalAnswer = {
			answer: false,
			checkBoxState: this.checkBoxFormControl.value
		}
		this.dialogRef.close(answer);
	}

	close(): void {
		const answer: IConfirmModalAnswer = {
			answer: null,
			checkBoxState: this.checkBoxFormControl.value
		}
		this.dialogRef.close(answer);
	}
}
